module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO40SugerenciasAjustarPresupuesto.2c76d4d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO40SugerenciasAjustarPresupuesto.mp4
// module id = 766
// module chunks = 1